const API_URL = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  const data = localStorage.getItem('authToken');
  return data || null;
}

async function request(endpoint, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${endpoint}`, { ...options, headers });
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || 'Something went wrong');
  }
  return data;
}

// Auth
export const authAPI = {
  signup: (name, email, password) => request('/auth/signup', { method: 'POST', body: JSON.stringify({ name, email, password }) }),
  login: (email, password) => request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  google: (credential) => request('/auth/google', { method: 'POST', body: JSON.stringify({ credential }) }),
  getMe: () => request('/auth/me'),
  updateProfile: (data) => request('/auth/profile', { method: 'PUT', body: JSON.stringify(data) }),
  changePassword: (currentPassword, newPassword) => request('/auth/change-password', { method: 'PUT', body: JSON.stringify({ currentPassword, newPassword }) }),
  forgotPassword: (email) => request('/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) }),
  resetPassword: (token, password) => request(`/auth/reset-password/${token}`, { method: 'PUT', body: JSON.stringify({ password }) }),
  deleteAccount: () => request('/auth/account', { method: 'DELETE' }),
};

// Progress
export const progressAPI = {
  get: () => request('/progress/get'),
  completeLesson: (day) => request('/progress/complete-lesson', { method: 'PUT', body: JSON.stringify({ day }) }),
  saveTestScore: (day, score, total) => request('/progress/test-score', { method: 'POST', body: JSON.stringify({ day, score, total }) }),
  reset: () => request('/progress/reset', { method: 'PUT' }),
};

// Settings
export const settingsAPI = {
  get: () => request('/misc/settings'),
  update: (data) => request('/misc/settings', { method: 'PUT', body: JSON.stringify(data) }),
};

// Contact
export const contactAPI = {
  submit: (data) => request('/misc/contact', { method: 'POST', body: JSON.stringify(data) }),
};

// AI — grammar check (existing) + Writing Studio
export const aiAPI = {
  grammarCheck: (sentence, context) => request('/misc/grammar-check', { method: 'POST', body: JSON.stringify({ sentence, context }) }),
  // Rephrase Studio
  rephrase:        (text, tone)       => request('/ai/rephrase', { method: 'POST', body: JSON.stringify({ text, tone }) }),
  rephraseTones:   ()                 => request('/ai/rephrase/tones'),
  // Email Assistant
  emailDraft:      (templateId, context) => request('/ai/email', { method: 'POST', body: JSON.stringify({ templateId, context }) }),
  emailTemplates:  ()                 => request('/ai/email/templates'),
  // WhatsApp → Professional
  whatsapp:        (text)             => request('/ai/whatsapp', { method: 'POST', body: JSON.stringify({ text }) }),
  // IELTS Writing
  ieltsEvaluate:   (task, text)       => request('/ai/ielts-write', { method: 'POST', body: JSON.stringify({ task, text }) }),
  // Penny coaching prompt
  pennyInsight:    (context)          => request('/ai/penny-insight', { method: 'POST', body: JSON.stringify({ context }) }),
  // Translator
  translate:       (text, source, target) => request('/ai/translate', { method: 'POST', body: JSON.stringify({ text, source, target }) }),
  translateLangs:  ()                 => request('/ai/translate/languages'),
};

// Admin
export const adminAPI = {
  overview:        ()           => request('/admin/overview'),
  listUsers:       (q)          => request('/admin/users' + (q ? `?q=${encodeURIComponent(q)}` : '')),
  updateUser:      (id, data)   => request(`/admin/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteUser:      (id)         => request(`/admin/users/${id}`, { method: 'DELETE' }),
  listPayments:    (status)     => request('/admin/payments' + (status ? `?status=${status}` : '')),
  listApiKeys:     ()           => request('/admin/api-keys'),
  toggleApiKey:    (keyId, on)  => request(`/admin/api-keys/${keyId}`, { method: 'PUT', body: JSON.stringify({ active: on }) }),
  listContacts:    ()           => request('/admin/contacts'),
  updateContact:   (id, status) => request(`/admin/contacts/${id}`, { method: 'PUT', body: JSON.stringify({ status }) }),
};

// Helper to save/clear auth
export function saveAuth(token, user) {
  localStorage.setItem('authToken', token);
  localStorage.setItem('currentUser', JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('currentUser');
  localStorage.removeItem('currentDay');
}
